{
  "id": "campaign-155",
  "name": "Willow Lea",
  "seed": "campaign:155",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "......................",
    ".........h........,...",
    "..............Y...,...",
    ".h.T..............,...",
    "....................x.",
    "x.........T...........",
    "..#.............h.....",
    "..............#.......",
    "............k.........",
    "w............h..m.....",
    "wwww+ww.........w+wwww",
    "......wwww..wwwww.....",
    "....h....ww+w.........",
    ".......#..............",
    "...................Y..",
    "..T..#...k............",
    "......................",
    ".....k.k..............",
    "..................m.x.",
    "..............k.......",
    "S........x............"
  ],
  "critters": [
    {
      "kind": "fox",
      "x": 8,
      "y": 4
    },
    {
      "kind": "deer",
      "x": 21,
      "y": 13
    },
    {
      "kind": "deer",
      "x": 21,
      "y": 12
    },
    {
      "kind": "deer",
      "x": 19,
      "y": 17
    },
    {
      "kind": "deer",
      "x": 19,
      "y": 16
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 21,
      "y": 20
    },
    {
      "kind": "gas",
      "x": 7,
      "y": 9
    },
    {
      "kind": "gas",
      "x": 19,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 17,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 12
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 18
    },
    {
      "kind": "coin",
      "x": 13,
      "y": 17
    },
    {
      "kind": "coin",
      "x": 16,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 19
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 13
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 19
    }
  ],
  "moles": {
    "hills": 4,
    "first": 30,
    "every": 20
  },
  "hills": [
    {
      "x": 9,
      "y": 13,
      "w": 5,
      "h": 5
    },
    {
      "x": 2,
      "y": 3,
      "w": 7,
      "h": 7
    }
  ],
  "generatorVersion": 3,
  "level": 155,
  "biome": "meadow",
  "par": {
    "reel": 15767,
    "push": 13614,
    "selfPropelled": 12678,
    "tractor": 10485,
    "zeroTurn": 8877,
    "fairway": 5488
  },
  "goldTime": {
    "reel": 15767,
    "push": 13614,
    "selfPropelled": 12678,
    "tractor": 10485,
    "zeroTurn": 8877,
    "fairway": 5488
  },
  "routeTries": {
    "par": {
      "reel": 0,
      "push": 0,
      "selfPropelled": 0,
      "tractor": 0,
      "zeroTurn": 0,
      "fairway": 3
    },
    "gold": {
      "reel": 0,
      "push": 0,
      "selfPropelled": 0,
      "tractor": 0,
      "zeroTurn": 0,
      "fairway": 3
    }
  }
}
